function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiobreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.5,
    height: 10,
    viewBox: "0 0 8.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M162.625-870v-3.75H162v-2.85a.864.864 0 0 1 .269-.631.861.861 0 0 1 .628-.269h1.303a.861.861 0 0 1 .628.269.864.864 0 0 1 .269.631v2.85h-.625v3.75zm.926-8.175a.881.881 0 0 1-.645-.268.876.876 0 0 1-.269-.644.881.881 0 0 1 .268-.645.876.876 0 0 1 .644-.269.881.881 0 0 1 .645.268.876.876 0 0 1 .269.644.881.881 0 0 1-.268.645.876.876 0 0 1-.644.269zm4.3 8.175v-3h-1.3l1.075-3.888a.8.8 0 0 1 .333-.454 1.012 1.012 0 0 1 .567-.159 1.012 1.012 0 0 1 .567.159.8.8 0 0 1 .333.454L170.5-873h-1.3v3zm.676-8.175a.881.881 0 0 1-.645-.268.876.876 0 0 1-.269-.644.881.881 0 0 1 .268-.645.876.876 0 0 1 .644-.269.881.881 0 0 1 .645.268.876.876 0 0 1 .269.644.881.881 0 0 1-.268.645.876.876 0 0 1-.645.269z",
    transform: "translate(-162 880)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiobreak);
export default __webpack_public_path__ + "static/media/biobreak.03d75125e2eac01cd0ac760a429737ce.svg";
export { ForwardRef as ReactComponent };